export const zonesToOptions = (zones = []) => {
    return zones.map((zone) => {
        return {
            key: zone.id,
            text: `${zone.name} (${zone.active?'active':'inactive'})`,
            value: zone.id,
            label: {
                color: (zone.active)?'green':'red',
                empty: true,
                circular: true,
                size: 'mini'
            },
        };
    });
};


export const zonesToOptionsWithAll = (zones = []) => {
    const options = zonesToOptions(zones);
    const allId = -1;
    options.push({
        key: allId,
        text: 'Toutes les zones',
        value: allId,
        label: {
            color: 'blue',
            empty: true,
            circular: true,
            size: 'mini'
        },
    });
    return options;
}

export const orderZonesByName = (zones = []) => zones.sort((a, b) => a.name.localeCompare(b.name));


// WEBPACK FOOTER //
// ./src/helpers/zones.js